<div class="h-100 d-flex justify-content-around align-items-center gap-0_5">
    <i class="cp icon-edit" (click)="onAction('edit')" tooltip="Edit config"></i>
    <i class="cp fa-trash-alt far" (click)="onAction('delete')" tooltip="Delete config"></i>
</div>
